import { COLLAT_TYPES } from "../redux/Tx/constants";
import { SettingsSelectors } from "../redux/Settings/selectors";
import { store } from "../index";
import { TX_TYPE_VALUES } from "../redux/Confirmations/constants";
import empty from "is-empty";
import { isNumber } from "mathjs";
import { getTermFromDate } from "./index";

export const toUiCollType = (collateralType, SelectableCCY = null) => {
    let uiCollType = { collType: null, collCcy: null, fr: null };

    if (collateralType?.ccy) {
        uiCollType.collCcy = collateralType.ccy[0];
    } else if (!empty(SelectableCCY)) {
        uiCollType.collCcy = SelectableCCY.filter((c) => !empty(c))[0];
    }

    if (collateralType?.type === "Cash") {
        uiCollType.collType = "CA";
        uiCollType.fr = "R";
    } else if (collateralType?.type === "NonCash") {
        uiCollType.collType = "NC";
        uiCollType.fr = "F";
    } else if (collateralType?.type === "CashPool") {
        uiCollType.collType = "CP";
        uiCollType.fr = "F";
    }

    return uiCollType;
};

export const toApiCollType = (collType, collCcy) => {
    if (!Object.keys(COLLAT_TYPES).includes(collType)) return null;
    let apiCollType = {
        type: COLLAT_TYPES[collType],
        ccy: collCcy ? [collCcy] : null,
    };
    if (collType === "NC") {
        apiCollType.nonCash = { schedule: "" };
    }
    return apiCollType;
};

export const getListSettingData = (data, listName) => {
    let listSetting = SettingsSelectors.ListSettings(store.getState()).find(
        (f) => f.name === listName
    );
    if (!listSetting) {
        listSetting = SettingsSelectors.DynamicAndClientPoolList(store.getState()).find(
            (l) => l.name === listName
        );
    }

    if (!listSetting) return data;

    const result = {};
    result.Callable =
        listSetting.callable === true || listSetting.callable === false
            ? listSetting.callable
            : null;
    result.Dividend =
        listSetting.dividend || listSetting.dividend === 0
            ? listSetting.dividend
            : null;

    const collateral = toUiCollType(
        listSetting.collateralType,
        data.SelectableCCY
    );
    result.CollateralType = collateral.collType;
    result.CollateralCCY = collateral.collCcy;
    result.FR = collateral.fr;

    result.TxType = listSetting.txType || TX_TYPE_VALUES.ANY;

    return { ...data, ...result, originListDetails: { ...result } };
};

export const convertCollateral = (entry) => {
    const economics = entry.offeredEconomics?.collateralType
        ? entry.offeredEconomics
        : entry.requestedEconomics;
    if (!economics) return {};

    const { collType, collCcy } = toUiCollType(economics.collateralType);

    return {
        CollateralType: collType,
        CollateralCCY: collCcy,
        SelectableCCY: entry.requestedEconomics?.collateralType?.ccy
            ? [...entry.requestedEconomics?.collateralType?.ccy]
            : null,
    };
};

// for validations
export const convertEntryByEconomics = (entry) => {
    const economics = entry.offeredEconomics || entry.requestedEconomics;
    if (!economics) return {};
    const ValueDate = economics.valueDate;
    const Maturity = economics.maturityDate;
    return {
        ...convertCollateral(entry),
        ValueDate,
        Intermediary: economics.intermediary,
        TxType: economics.txType,
        Term: getTermFromDate(ValueDate, Maturity),
    };
};

export const convertRate = (economics) => {
    if (!economics) return null;
    if (economics.fee) {
        return isNumber(economics.fee.rateBp)
            ? economics.fee.rateBp / 100.0
            : economics.fee.rateBp;
    } else if (economics.rateRebate) {
        return isNumber(economics.rateRebate.rateBp)
            ? economics.rateRebate.rateBp / 100.0
            : economics.rateRebate.rateBp;
    }
};
